/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { default_server } from "./../../services/api";
import TweenOne from "rc-tween-one";
import Drawer from "react-drag-drawer";
import "./../../assets/styles/BookDetail.css";
import Copyrights from "../copyrights";
import { playSong, pauseSong } from '../../utils/song'
import songsName from "../../enums/songsName";
import { useNetworkStatus } from "../../hooks/useNetworkStatus";
import AudioPlayerModal from '../audio-player-modal'
import { PRODUCT } from "../../consts/product";
import Button from "../button";
import OutlineButton from "../outline-button";

const BookDetail = props => {
  let BOOK = 0;

  const { isOnline } = useNetworkStatus()

  const isSurprise = props.appState === "firsttimevisit" ? true : false;
  const currentBookID = props.currentBookID;
  for (let i = 0; i < props.payload.listData.length; i++) {
    const element = props.payload.listData[i];
    if (element.bookId === currentBookID) {
      BOOK = i;
    }
  }

  const TOKEN = props.payload.token;
  const ITEM = props.payload.listData[BOOK];
  const GENDER = ""; //ITEM.bookAuthorGender === "F"? "Autora: " : "Autor: "
  const AUTHOR = ITEM.bookAuthor || "";
  const TITLE = ITEM.bookTitle || "";
  const content = `${GENDER} ${AUTHOR}`;
  const BOOK_AUDIO_FULL_URL = ITEM.bookAudioFull;
  const NARRATOR = ITEM.bookAudioFullSpeaker || 'Carregando...';

  const [show_download, toggle_download] = useState(false);
  const [audioPlayerModalIsOpen, setAudioPlayerModalIsOpen] = useState(false)

  const axios = require("axios");
  const postDownloadCounter = type => {
    axios.post(
      `${default_server}/quembaixou`,
      {
        livro: TITLE,
        token: TOKEN,
        produto: PRODUCT,
        tipo: type
      },
      {
        timeout: 10000,
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
  };

  return (
    <div className="w-full max-w-md mx-auto shadow-lg -mt-3 pt-3 bg-white pb-14">
      <TweenOne
        paused={isSurprise}
        animation={{ opacity: 1 }}
        id="book_detail"
        className={`book_detail_container`}
      >
        <p className="book_detail_infos">
          <p className="text-center text-black font-bold">{TITLE}</p>
          <p className="text-pallet-3">{content}</p>
        </p>

        <div className="flex flex-col justify-center items-center w-full px-4">
          {/* <button
            id="how-to-read"
            disabled={(!isOnline && !props.offlineBooksIds?.includes(currentBookID)) || props.openingBookId}
            onMouseEnter={() => {
              playSong(songsName.TAP)
            }}
            onClick={() => {
              if (props.openingBookId) {
                return
              }

              if (!props.isLoggedIn) {
                props.showExpanded()

                return
              }

              playSong(songsName.TAP)
              playSong(songsName.BUBBLES)
              props.changeReader(ITEM);
              postDownloadCounter(2);
            }}
          >
            Ler livro
          </button> */}

          <Button
            disabled={(!isOnline && !props.offlineBooksIds?.includes(currentBookID)) || props.openingBookId}
            onClick={() => {
              if (props.openingBookId) {
                return
              }

              if (!props.isLoggedIn) {
                props.showLoginModal()

                return
              }

              playSong(songsName.TAP)
              playSong(songsName.BUBBLES)
              props.changeReader(ITEM);
              postDownloadCounter(2);
            }}
          >
            Ler
          </Button>

          <Button
            disabled={(!isOnline && !props.offlineBooksIds?.includes(currentBookID)) || props.openingBookId}
            onClick={() => {
              if (!props.isLoggedIn) {
                props.showLoginModal()

                return
              }

              setAudioPlayerModalIsOpen(true)
            }}
          >
            Ouvir
          </Button>

          <Button
            kind="secondary"
            loading={props.downloadingBooksIds?.includes(currentBookID)}
            onClick={async () => {
              props.showExpanded()
            }}
            onMouseEnter={() => {
              playSong(songsName.TAP)
            }}
            disabled={!(isOnline && !props.offlineBooksIds?.includes(currentBookID))}
          >
            {props.offlineBooksIds?.includes(currentBookID) ? "Baixado" : "Baixar"}
          </Button>
        </div>

        <AudioPlayerModal
          bookTitle={TITLE}
          authorName={AUTHOR}
          narratorName={NARRATOR}
          bookCover={ITEM.bookCover}
          isOpen={audioPlayerModalIsOpen}
          audioUrl={BOOK_AUDIO_FULL_URL}
          onHideModal={() => setAudioPlayerModalIsOpen(false)}
        />

        <Drawer dontApplyListeners={true} open={show_download}>
          <Copyrights />
        </Drawer>
      </TweenOne>
    </div>
  );
};

export default BookDetail;
